import type { PlayerDto } from "./player.dto.js";
import type { CumulativeBoosterInventoryDto } from "./cumulative_boosters.dto.js";

export enum AuthProvider
{
  Guest = 'guest',
  Telegram = 'telegram',
  Google = 'google',
  Apple = 'apple',
  Facebook = 'facebook',
}

export interface LoginRequest
{
  provider: AuthProvider;
  provider_id: string;
  device_id?: string;
}

export interface LinkedProvider
{
  provider: string;
  provider_id: string;
  email: string | null;
  name: string | null;
}

export interface PlayerResponse extends CumulativeBoosterInventoryDto
{
  id: number;
  token: string;
  player_level: number;
  last_seen_level: number;
  music_enabled: boolean;
  sounds_enabled: boolean;
  language: string | null;
  coins: number;
  points: number;
  hearts: number;
  hearts_updated_at: string;
  max_hearts?: number;
  next_heart_at?: string | null;
  rewarded_levels: number[] | null;
  nickname: string | null;
  avatar_id: number;
  facebook_avatar_url: string | null;
  country: string | null;
  campaign_key: string | null;
  created_at: string;
  linked_providers: LinkedProvider[];
}

export interface LinkConflictData
{
  error:           string;
  current_player:  PlayerDto;
  existing_player: PlayerDto;
}
